import catalogFeeds from './catalogFeeds.json'

export const CATALOG_IDS = Object.keys(catalogFeeds)

const CALLABLE_BY_CATALOG = {
  combined: 'generateCombinedFacebookFeed',
  premium: 'generatePremiumXlsFeed',
  outlet: 'generateOutletXlsFeed',
}

const buildPlatformEntry = (platformConfig, meta) => ({
  id: meta.id,
  label: meta.label,
  icon: meta.icon,
  feedLabel: meta.feedLabel,
  feedUrl: platformConfig.publicUrl,
  downloadUrl: platformConfig.xlsxPublicUrl,
  downloadFileName: platformConfig.downloadFileName,
})

const PLATFORM_META = {
  facebook: {
    id: 'facebook',
    label: 'Facebook',
    icon: 'facebook-f',
    feedLabel: 'Facebook',
  },
  adwords: {
    id: 'adwords',
    label: 'AdWords',
    icon: 'google',
    feedLabel: 'Google Ads',
  },
}

export const getCatalogFeedRuntime = (catalog) => {
  const catalogConfig = catalogFeeds[catalog]

  if (!catalogConfig) {
    return null
  }

  return {
    catalog,
    callableName: CALLABLE_BY_CATALOG[catalog],
    dateKey: catalogConfig.facebook.requestsDateKey,
    platforms: [
      ...(catalogConfig.google ? [buildPlatformEntry(catalogConfig.google, PLATFORM_META.adwords)] : []),
      buildPlatformEntry(catalogConfig.facebook, PLATFORM_META.facebook),
    ],
  }
}

export default catalogFeeds
